// John Eldhose 20180720
import { RestfulPost } from './Restful';

export async function checkout(data) {
  const checkout = await RestfulPost('checkout', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return checkout;
}



// WEBPACK FOOTER //
// ./src/Api/checkout.js